export default "__VITE_ASSET__s4w0HH6d__"